//Author June Leow
//Date June 6th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, callBackGenerator, formatDateTime, formatNumber, stringToHexCode, generateSID, encodeParam} from '../../util/util';
import InfiniteScroll from 'react-infinite-scroll-component';
import {NavLink, useNavigate} from 'react-router-dom';
import ReportFilter  from '../report/report-filter';
import {Row, Col} from 'reactstrap';
import React, {useReducer, useEffect, useRef} from 'react';

//initialize the state
const initialState = {
  conditions:[],
  limit: 35,
  offset: 0,
  hasMoreConditions: true,
  loading: false,
  sort: 'c.datetime_created',
  order: 'ASC',
  status: 'Started',
  clients: [],
  client: '',
  loan_num:'',
  borrower:'',
  state:'',
  county:'',
  city:'',
  street:'',
  accountManager:'',
  accountManagers:[],
  statuses: [{id:2,name:'Started'},{id:3,name:'Processed'},{id:4,name:'Completed'},{id:5,name:'Cancelled'}],
  states:[
    {key:'Alabama',value:'Alabama'},{key:'Alaska',value:'Alaska'},{key:'Arizona',value:'Arizona'},{key:'Arkansas',value:'Arkansas'},{key:'California',value:'California'},{key:'Colorado',value:'Colorado'},{key:'Connecticut',value:'Connecticut'},{key:'Delaware',value:'Delaware'},{key:'Florida',value:'Florida'},{key:'Georgia',value:'Georgia'},{key:'Hawaii',value:'Hawaii'},{key:'Idaho',value:'Idaho'},{key:'Illinois',value:'Illinois'},{key:'Indiana',value:'Indiana'},{key:'Iowa',value:'Iowa'},{key:'Kansas',value:'Kansas'},{key:'Kentucky',value:'Kentucky'},{key:'Louisiana',value:'Louisiana'},{key:'Maine',value:'Maine'},{key:'Maryland',value:'Maryland'},{key:'Massachusetts',value:'Massachusetts'},{key:'Michigan',value:'Michigan'},{key:'Minnesota',value:'Minnesota'},{key:'Mississippi',value:'Mississippi'},{key:'Missouri',value:'Missouri'},{key:'Montana',value:'Montana'},{key:'Nebraska',value:'Nebraska'},{key:'Nevada',value:'Nevada'},{key:'New Hampshire',value:'New Hampshire'},{key:'New Jersey',value:'New Jersey'},{key:'New Mexico',value:'New Mexico'},{key:'New York',value:'New York'},{key:'North Carolina',value:'North Carolina'},{key:'North Dakota',value:'North Dakota'},{key:'Ohio',value:'Ohio'},{key:'Oklahoma',value:'Oklahoma'},{key:'Oregon',value:'Oregon'},{key:'Pennsylvania',value:'Pennsylvania'},{key:'Rhode Island',value:'Rhode Island'},{key:'South Carolina',value:'South Carolina'},{key:'South Dakota',value:'South Dakota'},{key:'Tennessee',value:'Tennessee'},{key:'Texas',value:'Texas'},{key:'Utah',value:'Utah'},{key:'Vermont',value:'Vermont'},{key:'Virgin Islands',value:'Virgin Islands'},{key:'Virginia',value:'Virginia'},{key:'Washington',value:'Washington'},{key:'Washington DC',value:'Washington DC'},{key:'West Virginia',value:'West Virginia'},{key:'Wisconsin',value:'Wisconsin'},{key:'Wyoming',value:'Wyoming'}
  ],
  rush:'',
  pipelineStatusCount:[],
  totalCount:0
};

//reducer function that perform state update
const reducer = getReducer();


const Conditions  = (props)=>{
  const controller = new AbortController();
  const newsid = useRef(generateSID());
  const history = useNavigate();
  const [state, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpGet = getAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    if(state.conditions.length<=0 && state.hasMoreConditions){
        loadMore();
        getPipelineStatusCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[state]);

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  //this function refresh the list of orders pipeline
  const refreshList = ()=>{
    let SID = generateSID();
    newsid.current = SID; 
    setState({
      conditions:[],
      totalCount:0,
      hasMoreConditions:true,
      offset:0
    });

    getPipelineStatusCount();
  }

  //click handler that switch the state of sorting order then call the function to refresh the list
  //to achieve the "sorting"
  const columnClickHandler = (col)=>{
    if(state.sort===col){
      if(state.order==='ASC')
        setState({order:'DESC'});
      else
        setState({order:'ASC'});
    }
    else
      setState({order:'ASC', sort:col});
    refreshList();
  }

  const setStatus = (status)=>{
    setState({status:status});
    refreshList();
  }

  const renderSortIcon = (col)=>{
    if(state.sort===col){
      if(state.order==='ASC')
        return <i className="red-color fa fa-arrow-down"></i>
      else
        return <i className="red-color fa fa-arrow-up"></i>
    }
  }

  //render function for infinite scroller
  const renderConditions = ()=>{
    let extraColumn;

    if(state.role==='appraiser_master')
      extraColumn = <th width="10%" ><i className="fa fa-user"></i>&nbsp;Appraiser</th>



    return (
      <div>
        <table className="primary-table">
          <thead>
            <tr>
              <th className="cursor-pointer" width="10%" onClick={()=>columnClickHandler('reference_num')}><i className="fa fa-search"></i>&nbsp;Reference # {renderSortIcon('reference_num')}</th>
              {extraColumn}
              <th className="cursor-pointer" width="10%" onClick={()=>columnClickHandler('loan_num')}><i className="fa fa-folder"></i>&nbsp;Loan # {renderSortIcon('loan_num')}</th>
              <th className="cursor-pointer" width="10%" onClick={()=>columnClickHandler('CONCAT(borrower_f_name," ",borrower_l_name)')}><i className="fa fa-user"></i>&nbsp;Borrower {renderSortIcon('CONCAT(borrower_f_name," ",borrower_l_name)')}</th>
              <th className="cursor-pointer" width="20%" onClick={()=>columnClickHandler('property_street')}><i className="fa fa-map-marker"></i>&nbsp;Property Address {renderSortIcon('property_street')}</th>
              <th className="cursor-pointer" onClick={()=>columnClickHandler('')}><i className="fa fa-info-circle"></i>&nbsp;Order Information {renderSortIcon('')}</th>
              <th className="cursor-pointer" width="10%" onClick={()=>columnClickHandler('datetime_submitted')}><i className="fa fa-calendar-o"></i>&nbsp;Date Submitted {renderSortIcon('datetime_submitted')}</th>
            </tr>
          </thead>
          <tbody>
          {
            state.conditions.map(
              (condition, index)=>{

                let extraColumnData;

                if(state.role==='appraiser_master')
                  extraColumnData = <td>{condition.appraiser}</td>
                return (

                  <tr key={index} onClick={()=>window.open("condition/"+condition.appraisal_fk)}>
                    <td><NavLink className="link-color" onClick={(e)=>{e.preventDefault();}} to={"/condition/"+condition.appraisal_fk}><b>{condition.reference_num}</b></NavLink></td>
                    {extraColumnData}
                    <td>{condition.loan_num}</td>
                    <td>{condition.borrower_f_name+' '+condition.borrower_l_name}</td>
                    <td>{condition.property_street+' '+condition.property_city+', '+condition.property_state+' '+condition.property_zip}</td>
                    <td>
                      <i className="fa fa-tags icon-color"></i>&nbsp;
                      {condition.appraisal_type}
                      <br/>
                      <i className="fa fa-home icon-color"></i>&nbsp;
                      {condition.property_type}
                      <br/>
                      <i className="fa fa-hashtag icon-color"></i>&nbsp;
                      {condition.loan_purpose}
                    </td>
                    <td>{formatDateTime(condition.datetime_created)}</td>
                  </tr>
                );
              }
            )
          }
          </tbody>
        </table>
      </div>
    )
  }

  //API call
  const getPipelineStatusCount = ()=>{
    let borrower = encodeParam(state.borrower);
    let loan_num = encodeParam(state.loan_num);
    let street = encodeParam(state.street);
    let city = encodeParam(state.city);
    let county = encodeParam(state.county);

    let url = 'condition/pipeline/count/status='+state.status+'&borrower='+borrower+'&loan_num='+loan_num+'&state='+state.state+'&county='+county+'&city='+city+'&street='+street+'&client='+state.client+'&accountManager='+state.accountManager+'&rush='+state.rush;
    let callBack = apiCallBack([{state:'pipelineStatusCount', key:'data'}]);
    httpGet(url, '','Oops, something went wrong and could not load the information of your pipeline. Please try again later.', callBack);
  }

  const loadMore = ()=>{
    //do not load if there is no more conditions or it's loading data
    if(state.hasMoreConditions&&!state.loading){
      //set loading equals to true so it won't fire off before we are done
      setState({loading:true});
      let sID = newsid.current;

      let borrower = encodeParam(state.borrower);
      let loan_num = encodeParam(state.loan_num);
      let street = encodeParam(state.street);
      let city = encodeParam(state.city);
      let county = encodeParam(state.county);

      let url = 'condition/get/limit='+state.limit+'&offset='+state.offset+'&order='+state.order+'&sort='+state.sort+'&status='+state.status+'&client='+state.client+'&loan_num='+loan_num+'&borrower='+borrower+'&state='+state.state+'&county='+county+'&city='+city+'&street='+street+'&accountManager='+state.accountManager+'&rush='+state.rush;

      //callback handler that update the state when http request return
      let callBack = (response)=>{
        console.log(response);

        if(sID===newsid.current){

          let code = response.data?response.data.code:undefined;
          if(code!=='00'){
            setState({hasMoreConditions:false});
          }
          else{
            let newCondition = response.data.data;
            let hasMoreConditions = true;
            let newOffset = state.offset;
            let totalCount = response.data.count;

            //if http request return empty then no more results, end of list
            if(newCondition.length<=0){
              hasMoreConditions = false;
            }
            else{
              //increment the offset
              newOffset = state.offset + 1;
            }

            //concat the current array of announcement
            if(state.conditions.length>0){
              let temp = [...state.conditions,...newCondition];

              setState({conditions:temp});
            }
            else
              setState({conditions:newCondition});

            setState({hasMoreConditions:hasMoreConditions, offset:newOffset, totalCount:totalCount});
          }
        }
      };
      callBack = callBack.bind(this);

      //error handler when the http request return with error
      let errorCallBack = apiCallBack([{state:'hasMoreConditions', value:false}]);

      //collect the promise and wait for it to finish performing it's task
      let promises = httpGet(url, '','Oops, something went wrong and could not load conditions. Please try again later.', callBack, errorCallBack);
      promises
        .then(
          function(result){
            console.log(result);
            //set loading equals to false so the function could be fire off once again
            setState({loading:false});
          }
        );
    }
  }

  //render
  let pipelineStatusCounts;

  if(state.pipelineStatusCount.length>0){
    pipelineStatusCounts = state.pipelineStatusCount.map(
      (pipelineStatus,index)=>{
        return(
          <div key={index} className={"pipeline-stage"+(pipelineStatus.status===state.status?" active":"")} onClick={()=>setStatus(pipelineStatus.status)}>
            <span className="my-badge3">{pipelineStatus.count}</span> {pipelineStatus.status}
          </div>
        )
      }
    );
  }
  
  let reportFiltersConfig = [
    {id:'orderStatus',value:state.status, updateFunc:(v)=>setState({status:v}), width:'3', labelClassName:"no-margin-bottom orange-color"},
    {id:'custom',value:state.loan_num, updateFunc:(v)=>setState({loan_num:v}), width:'3', label:'Loan # / Reference #'},
    {id:'custom',value:state.borrower, updateFunc:(v)=>setState({borrower:v}), width:'3', label:'Borrower'},
    {id:'state',value:state.state, updateFunc:(v)=>setState({state:v}), width:'3'},
    {id:'county',value:state.county, updateFunc:(v)=>setState({county:v}), width:'3'},
    {id:'city',value:state.city, updateFunc:(v)=>setState({city:v}), width:'3'},
    {id:'custom',value:state.street, updateFunc:(v)=>setState({street:v}), width:'3', label:'Street'},
    {id:'button',value:'Submit', updateFunc:refreshList, width:'3', className:"align-right", color:"warning"},
  ];

  return <div>
    <InfiniteScroll
      className="my-well"
      dataLength={state.conditions.length} //This is important field to render the next data
      next={loadMore}
      hasMore={state.hasMoreConditions}
      loader={<center>Loading more conditions...</center>}
      scrollableTarget="contentContainer"
    >
      <div className="page-title">
        <Row>
          <Col sm="8">
            <i className="fa fa-reorder"></i>&nbsp;Conditions
          </Col>
          <Col sm="4" className="align-right">
      
          </Col>
        </Row>
      </div>
      <ReportFilter {...props} configs={reportFiltersConfig}/>
      <div className="my-divider"></div>
      <Row className="low-line-height">
        <Col sm="6">
            <div>{formatNumber(state.totalCount)} conditions in queue<br/><br/></div>
        </Col>
        <Col sm="6">
          
        </Col>
      </Row>
      <div>
        {pipelineStatusCounts}
      </div>
      {renderConditions()}
    </InfiniteScroll>
  </div>;
}


export default Conditions;
